import { render, staticRenderFns } from "./AuthBasicLayout.vue?vue&type=template&id=8cd52336&"
import script from "./AuthBasicLayout.vue?vue&type=script&lang=js&"
export * from "./AuthBasicLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cd52336')) {
      api.createRecord('8cd52336', component.options)
    } else {
      api.reload('8cd52336', component.options)
    }
    module.hot.accept("./AuthBasicLayout.vue?vue&type=template&id=8cd52336&", function () {
      api.rerender('8cd52336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Layout/AuthBasicLayout.vue"
export default component.exports